import httpClient from "../../utils/httpClient";

const userModule = {
    namespaced: false,
    state: {
        loaded: false,
        connection: {
            lastUpdate: null,
            local: null,
            remote: null,
            host: null,
            forwarded: null,
            realIp: null,
            macAddress: null,
            browserUuid: null,
            dorm: {
                code: null,
                name: null,
            },
            isLoggedIn: false,
            hasAccount: false,
            isLocalConnection: false,
            isAccessGood: false,
            account: {
                accountId: null,
                accountUuid: null,
                name: null,
                surname: null,
                accountType: null,
                accountStatus: "INACTIVE"
            },
            device: {
                status: null
            }
        }
    },
    mutations: {
        updateUser(state, payload) {
            localStorage.setItem("isLoggedIn", payload.isLoggedIn)

            state.connection.lastUpdate = Date();
            state.connection.local = payload.local;
            state.connection.remote = payload.remote;
            state.connection.host = payload.host;
            state.connection.forwarded = payload.forwarded;
            state.connection.realIp = payload.realIp;
            state.connection.macAddress = payload.macAddress;
            state.connection.browserUuid = payload.browserUuid;
            state.connection.isLoggedIn = payload.isLoggedIn;
            state.connection.canLogin = payload.canLogin;
            state.connection.hasAccount = payload.hasAccount;
            state.connection.isLocalConnection = payload.isLocalConnection;
            state.connection.isAccessGood = payload.isAccessGood;
            state.connection.dorm = {
                code: payload.dorm.code,
                name: payload.dorm.name
            };
            if (payload.device) {
                state.connection.device = {
                    status: payload.deviceStatus
                }
            }
            if (payload.account) {
                state.connection.account = {
                    accountId: payload.account.accountId,
                    accountUuid: payload.account.accountUuid,
                    name: payload.account.name,
                    surname: payload.account.surname,
                    accountType: payload.account.accountType,
                    accountStatus: payload.account.accountStatus
                };
            }
        },
    },
    getters: {
        getUserConnectionDetails: (state) => {
            return state.connection;
        },
    },
    actions: {
        getUserConnectionDetails() {
            httpClient.get("/identity").then((response) => {
                this.commit("updateUser", response);
                localStorage.setItem("browserUuid", response.browserUuid);
                httpClient.defaults.headers.common = {
                    "t-browser": response.browserUuid,
                };
            });
        },
    },
};

export default userModule;
